import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal"
import SimpleTable from "../../../../components/SimpleTable";
import { useCompanyDateFormat } from "../../../../utils/hooks/company";
import { useColumns } from "./useColumns";

function InfoModal({ isOpen, values, close }) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const columns = useColumns({ dateFormat });

    return (
        <Modal
            title={t("info")}
            isOpen={isOpen}
            size="lg"
            centered
        >
            <div className="mx-2 my-4" style={{ maxHeight: 300, overflow: "auto" }}>
                <SimpleTable data={values || []} columns={columns} footer={false} />
            </div>

            <div className="d-flex justify-content-end m-4">
                <Button
                    type="button"
                    color="dark"
                    onClick={close}
                >
                    {t("close")}
                </Button>
            </div>
        </Modal>
    );
}

export default InfoModal;
